import { css } from "styled-components";

export const adminIconStyle = css`
  box-shadow: none;
  padding: 5px;
  height: 26px;
  width: 26px;
  background: #243a62;
  transition: background 0.3s ease-in-out;
  &:hover {
    background: #1c2636;
  }
`;
